<template>
  <v-container class="dr-property-panel-container">
    <v-row>
      <v-col cols="12" sm="12">
        <template v-for="(prop, index) in schema.properties">
          <component
            :readonly="false"
            :is="choiceComponent(prop)"
            :key="index"
            :propName="index"
            :value="choiseValue(index)"
            :schema="getSchema(prop)"
            :objectName="getObjectName(prop)"
            v-if="index != '$ID'"
            @input="changeValue(index, $event)"
            @change="propertyChanged(index)"
            :contract="contract"
          ></component>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moduleMixin from '../../mixins/changedModel-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  name: 'dr-property-panel',
  props: ['schema', 'value','readonly', 'contract','jsonPatchPathToTarget'],
  mixins: [moduleMixin, jsonPatchMixin],
  data() {
    return {
      lastValues: {}
    }
  },
  computed: {
    // Путь к проперти для josn патчей
    defaultPathToTarget() {
      if (this.jsonPatchPathToTarget) {
        return this.jsonPatchPathToTarget
      }

      return `Modules.${this.currentModuleRouteParam}`
    },
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    // Текущая страница
    pageId() {
      return this.$route.params.pageId
    },
    moduleName() {
      return this.$store.state.global.currentModuleRouteParam
    }
  },
  methods: {
    // Сохранить в дату предыдущее значение localValue
    storeLastValue(index, value) {
      if (!this.lastValues[index]) {
       this.lastValues[index] = [this.localValue[index], value]
       return
      }
      this.lastValues[index].push(value)
    },
    propertyChanged(property) {
      if (this.readonly) {
        return
      }
      const oldValue = this.lastValues[property].at(-2)
      this.jsonPatchReplace(this.localValue, property, this.choiseValue(property), oldValue)
    },
    // Отображения значения свойства из измененной модели или из главной
    choiseValue(propName) {
      return this.readonly ? this.getValueFromChangedModel(propName, this.localValue) : this.localValue[propName]
    },
    // Изменение значения свойства
    changeValue(index, value) {
      this.storeLastValue(index, value)

      // TODO: При наличии пользовательских изменений админ все равно меняет основную модель
      if (!this.readonly) {
        this.$set(this.localValue, index, value)
        let newValue = { ...this.localValue }
        this.localValue = newValue
        // TODO: При изменении модели админом перетереть такое же свойство виджета в пользовательской
        // TODO: Для админа блочить свойства у которых есть пользовательские значения
      } else {
        if (this.$route.name === 'navigationCommon') {
          // Обновлдение свойств Navigation
          this.updateNavigationInChangedModel(index, value, this.localValue)
          this.$emit('updateNavigation')
          return
        }
        this.updateChangedModel(index, value, this.localValue)
      }
    },
    choiceComponent(prop) {
      if (prop.type == 'boolean') {
        return 'dr-property-check-box'
      }
      if (prop.type == 'multiple-select') {
        return 'dr-property-multiple-select'
      }
      if (prop.enum) {
        return 'dr-property-select'
      }
      if (prop.component) {
        return prop.component
      }
      if (prop.type == 'object') {
        return 'dr-property-object-field'
      }
      if (prop.type == 'array') {
        return
      }
      // для остальных создаем простые текстовые поля
      return 'dr-property-text-field'
    },
    getSchema(prop) {
      if (prop.type == 'object') {
        return prop.properties
      }
      return prop
    },
    getObjectName(prop) {
      if (prop.type == 'object' && 'name' in prop) {
        return prop.name
      }
      return undefined
    }
  }
}
</script>
<style>
.header-props-component {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  padding-right: 5px;
  user-select: none;
}
.dr-property-panel-container {
  padding-bottom: 0px;
  padding-top: 0px;
}
</style>
